import { getEnvironmentConfig, type DomainEnvironmentConfig } from './domainConfigLoader';

// Get configuration based on current domain
const config: DomainEnvironmentConfig = getEnvironmentConfig();

// Export configuration with the same interface as window.env
const env = {
  PUBLIC_API_URL: config.PUBLIC_API_URL,
  PUBLIC_ENABLE_FEATURE_IA_SUGGESTION: config.PUBLIC_ENABLE_FEATURE_IA_SUGGESTION,
  HOME_DIPROPNEU_URL: config.HOME_DIPROPNEU_URL,
  SOUSCRIPTION_DIPROPNEU_URL: config.SOUSCRIPTION_DIPROPNEU_URL,
  DECLARATION_SAV_URL: config.DECLARATION_SAV_URL,
  GESTION_SAV_URL: config.GESTION_SAV_URL,
  ENABLE_SENTRY: config.ENABLE_SENTRY || 'false',
  STRIPE_PUBLIC_KEY: config.STRIPE_PUBLIC_KEY || 'false',
  STRIPE_TEST_PUBLIC_KEY: config.STRIPE_TEST_PUBLIC_KEY || '',
  AWS_S3_FILES_URL: config.AWS_S3_FILES_URL || 'https://files-demo.affinicar.com'
};

// Set window.env for backward compatibility with code that directly accesses window.env
if (typeof window !== 'undefined') {
  (window as any).env = env;
}

// Default export to replace imports from PublicEnv/env.ts
export default env;

// Named exports for direct access
export const { PUBLIC_API_URL, PUBLIC_ENABLE_FEATURE_IA_SUGGESTION, ENABLE_SENTRY } = env;